module.exports = __webpack_public_path__ + "static/sunrise-1e1a49ae52536dd8a6385ae4f6a36a49.jpeg";